/**
 * 회원 아이디(폰번호) 변경 모달 ($j.Ui.JBModal.target 결합).
 * 레거시 public/skw_3300_idchange.php 대체.
 *
 * 사용법:
 *   $j.Ui.JBModal.target('idchange-modal', {
 *       target: '$j.F.Admin.Member.IdChangeForm',
 *       data:   { mbNo: 123 },
 *       title:  '아이디 변경',
 *       width:  '500px',
 *   });
 */
import Util from '../../../Common/Util';

export default class IdChangeForm {
    constructor() { this.$wrap = null; this.checked = ''; }
    destroy() {}

    init() {
        this.mbNo = this.data.mbNo;
        $(`#${this.id}`).html('<div style="padding:20px;text-align:center;color:#888">로딩중...</div>');
        this.load();
    }

    load() {
        const self = this;
        $.ajax({
            type: 'get',
            url: '/adm/ajax/member/id/change/form',
            data: { mb_no: self.mbNo },
            dataType: 'json',
            success(data) {
                if (!data.result) {
                    $(`#${self.id}`).html(`<div style="padding:20px;text-align:center;color:var(--adm-kw-red, red)">${Util.escapeHtml(data.message || '데이터를 불러오지 못했습니다.')}</div>`);
                    return;
                }
                self.state = data;
                self.render();
                self.bind();
            },
            error() {
                $(`#${self.id}`).html('<div style="padding:20px;text-align:center;color:var(--adm-kw-red, red)">데이터를 불러오지 못했습니다.</div>');
            },
        });
    }

    render() {
        const s = this.state;
        let historyRows;
        if (!s.history || s.history.length === 0) {
            historyRows = '<tr><td style="height:50px">아이디 변경내역이 없습니다.</td></tr>';
        } else {
            historyRows = `
                <tr>
                    <th style="width:45%">변경일</th>
                    <th style="width:35%">이전아이디</th>
                    <th style="width:20%">작업자</th>
                </tr>`;
            s.history.forEach(r => {
                historyRows += `<tr>
                    <td>${Util.escapeHtml(r.change_date)}</td>
                    <td>${Util.escapeHtml(r.before_id)}</td>
                    <td>${Util.escapeHtml(r.change_by_name)}</td>
                </tr>`;
            });
        }

        const html = `
        <style>
            .idchange-form { padding:10px }
            .idchange-form .xtable { width:100%; border-collapse:collapse }
            .idchange-form .xtable th, .idchange-form .xtable td { font-size:13px; border:1px solid #ccc; padding:8px 12px }
            .idchange-form .xtable th { background:#f0f0f0; text-align:left; white-space:nowrap; font-weight:bold; width:30% }
            .idchange-form #idchange-old { font-size:14px; font-weight:600 }
            .idchange-form .idchange-rule { margin-top:8px; font-size:12px; line-height:1.7; color:#666 }
            .idchange-form .idchange-rule b { color:#000 }
            .idchange-form .history-table { width:100%; border-collapse:collapse; margin-top:15px }
            .idchange-form .history-table th, .idchange-form .history-table td { font-size:12px; border:1px solid #ccc; padding:6px 10px; text-align:center }
            .idchange-form .history-table th { background:#004080; color:#fff; font-weight:bold }
        </style>
        <div class="idchange-form">
            <table class="xtable">
                <tr>
                    <th>기존 아이디</th>
                    <td id="idchange-old">${$('<i>').text(s.oldId ?? '').html()}</td>
                </tr>
                <tr>
                    <th>변경할 아이디</th>
                    <td>
                        <input type="text" id="idchange-new" style="width:150px;height:28px;padding:4px" maxlength="20">
                        <div id="idchange-msg" style="margin-top:5px;font-size:12px;color:var(--adm-text-muted)">다 입력하면 자동으로 확인합니다</div>
                        <div class="idchange-rule">
                            <b>10자 이상</b>이어야 하고, 이미 쓰는 아이디는 쓸 수 없습니다.
                        </div>
                    </td>
                </tr>
            </table>
            <div style="text-align:center;margin-top:15px">
                <button type="button" id="idchange-save-btn" style="display:none;width:120px;height:38px;background:#004080;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:13px">변경하기</button>
            </div>
            <div style="margin-top:20px;font-size:13px;font-weight:bold">아이디 변경내역</div>
            <table class="history-table">${historyRows}</table>
        </div>`;
        $(`#${this.id}`).html(html);

        // ⚠ 공용 `registerPhoneHandler` 를 쓰지 않는다. 그 포맷터는 앞 3자리 뒤를 **8자리로
        //   자르므로**(Common/Util.phoneNumber) 소속자 아이디의 순번이 사라진다 —
        //   `010-3626-2114003` 을 치면 `010-3626-2114` 가 돼 **입력 자체가 안 됐다**.
        //   (소속자 아이디는 실데이터 1,142명. `MemberNamingService::empId` 가 만든다)
        //   여기서는 앞 11자리만 전화번호꼴로 묶고 **나머지는 그대로 붙인다.**
        // ⚠ 이름공간(`.fmt`)을 준다. `bind()` 가 `.off('input.chk')` 로 자기 것만 걷어내는데,
        //   예전처럼 이름 없이 걸면 그 `.off` 에 **이 포맷터까지 함께 지워졌다.**
        //
        // ⚠ **아이디가 번호가 아닐 수 있다.** `mem_id_type` 이 말해준다 —
        //   P(16,532) 핸드폰 / S(1,637) 소셜(`K_…`·`N_…`) / I(246) 직접입력(이메일·`test` 등).
        //   그래서 **숫자·하이픈만 든 값일 때만** 손댄다. 글자가 섞이면 그대로 둔다 —
        //   손대면 소셜 아이디가 통째로 지워진다.
        $(`#${this.id}`).find('#idchange-new').off('input.fmt').on('input.fmt', function () {
            const v = String(this.value);
            if (!/^[0-9-]*$/.test(v)) return;          // 번호가 아닌 아이디 — 건드리지 않는다

            const d = v.replace(/-/g, '');
            const head = d.slice(0, 11), tail = d.slice(11);
            let out = head;
            if (head.length > 7)      out = `${head.slice(0,3)}-${head.slice(3,7)}-${head.slice(7)}`;
            else if (head.length > 3) out = `${head.slice(0,3)}-${head.slice(3)}`;
            this.value = out + tail;
        });
    }

    bind() {
        const self = this;
        const $w = $(`#${this.id}`);
        $w.find('#idchange-save-btn').off('click').on('click', () => self.save());

        // 중복확인은 **자동으로** 한다. 버튼을 따로 두면 안 누르고 [변경하기]를 눌러
        // "중복 검사 후 실행해 주세요" 를 보는 일이 반복된다 — 검사는 사람이 기억할 일이 아니다.
        // 치는 동안 매 글자마다 묻지 않게 잠깐 기다렸다 보낸다.
        $w.find('#idchange-new').off('input.chk').on('input.chk', function () {
            self.checked = '';
            self._syncSaveBtn();          // 값이 바뀌면 이전 검사결과는 무효다
            clearTimeout(self._t);

            const v = String($(this).val()).trim();

            if (v === '') { self._msg('다 입력하면 자동으로 확인합니다'); return; }

            const fail = self._localFail(v);
            if (fail) { self._msg(fail, 'fail'); return; }   // 서버에 묻기 전에 이유를 말한다

            self._msg('확인중…');
            self._t = setTimeout(() => self.check(), (window.G5 && G5['DEBOUNCE_TIME']) || 350);
        });
    }

    /**
     * [변경하기] 는 **검사를 통과했을 때만 보인다.**
     * 예전에는 늘 떠 있어서 누르면 "중복 검사 후 실행해 주세요" 를 받았다 —
     * 누를 수 없는 버튼을 보여주고 눌러서 안 된다고 말하는 것보다, 될 때만 내미는 편이 낫다.
     */
    _syncSaveBtn() {
        const ok = !!this.checked && this.checked.length >= 10;
        $(`#${this.id}`).find('#idchange-save-btn').toggle(ok);
    }

    /** 안내 한 줄 — tone: 'fail'(빨강) · 'ok'(파랑) · ''(회색 안내) */
    _msg(text, tone = '') {
        const color = tone === 'fail' ? 'var(--adm-kw-red, red)'
                    : tone === 'ok'   ? 'var(--adm-kw-blue, blue)'
                    :                   'var(--adm-text-muted)';
        $(`#${this.id}`).find('#idchange-msg').css('color', color).text(text);
    }

    /**
     * 화면에서 거를 수 있는 것 — **왜 안 되는지 말한다.**
     * 예전에는 짧게 쳐도 '다 입력하면 자동으로 확인합니다' 만 떠서, 몇 자가 모자란지도
     * 같은 아이디를 다시 넣은 것인지도 알 수 없었다.
     *
     * 서버가 막는 것은 `10자 이상` + `중복 아님` 둘이다 (MemberController::changeId).
     * 여기서는 그 둘에 더해 **같은 아이디**·**빈칸**을 먼저 걸러 헛질의를 줄인다.
     * @returns {string} 실패사유 (통과면 빈 문자열)
     */
    _localFail(v) {
        if (v === '')            return '';                              // 아직 안 썼다 — 실패가 아니다
        if (/\s/.test(v))        return '빈칸은 넣을 수 없습니다.';
        if (v === this.state.oldId) return '지금 쓰는 아이디와 같습니다.';
        if (v.length < 10)       return `10자 이상이어야 합니다. (지금 ${v.length}자)`;
        return '';
    }

    /** 중복확인 — 입력이 멈추면 자동으로 돈다 (bind 참고). 결과는 `checked` 에 남고 save 가 본다 */
    check() {
        const hp = String($(`#${this.id}`).find('#idchange-new').val()).trim();
        if (this._localFail(hp) || hp === '') return;   // 자동 호출이라 알럿으로 막지 않는다

        const self = this;
        $.ajax({
            type: 'POST',
            url: '/adm/ajax/member/id/check',
            data: { changenum: hp },
            dataType: 'json',
            success(data) {
                if (data.exists) {
                    self._msg('이미 다른 회원이 쓰는 아이디입니다.', 'fail');
                    self.checked = '';
                } else {
                    self._msg('변경 가능한 아이디 입니다.', 'ok');
                    self.checked = hp;
                }
                self._syncSaveBtn();
            },
            error() {
                self._msg('확인하지 못했습니다. 잠시 후 다시 시도해 주세요.', 'fail');
                self.checked = '';
                self._syncSaveBtn();
            },
        });
    }

    save() {
        // 자동확인이 아직 안 끝났거나 중복이면 여기서 막는다 — 검사 결과가 정본이다
        if (!this.checked || this.checked.length < 10) { alert('사용 가능한 번호인지 확인 중입니다. 잠시 후 다시 눌러주세요.'); return; }
        if (!confirm(`입력한 전화 번호 [ ${this.checked} ] 로 변경할까요?`)) return;

        const mbNo = this.mbNo;
        $.ajax({
            type: 'POST',
            url: `/adm/ajax/member/${mbNo}/id`,
            data: { changenum: this.checked },
            dataType: 'json',
            success(data) {
                if (data.result) {
                    $j.F.Admin.Util.tsalert('success', '아이디가 변경되었습니다.');
                    $j.Ui.JBModal.close('idchange-modal');
                    location.replace(`/adm/member/edit?mb_no=${mbNo}`);
                } else {
                    $j.F.Admin.Util.tsalert('error', data.message || '변경에 실패했습니다.');
                }
            },
            error(xhr) { alert(`요청 중 오류가 발생했습니다. (${xhr.status})`); },
        });
    }
}
